module.exports = __webpack_public_path__ + "static/visual_2_2_dont-94e856607ad086104f2f568257a53346.png";